import { render, staticRenderFns } from "./part-h-koperate.vue?vue&type=template&id=85272e80&"
import script from "./part-h-koperate.vue?vue&type=script&lang=js&"
export * from "./part-h-koperate.vue?vue&type=script&lang=js&"
import style0 from "./part-h-koperate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports